import { Component, OnDestroy, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { EventsEmitterService } from '../../services/events-emitter.service'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'

import { User, Sex } from '../../models/user.model'

@Component({
  selector: 'ld-user',
  template: require('./user.component.html'),
  styles: [require('./user.component.css')]
})
export class UserComponent implements OnDestroy {

  @ViewChild('userFormComponent') userFormComponent
  private user = new User()
  private editing$
  private routingSub
  private Sex = Sex

  constructor (
    private eventsEmitterService: EventsEmitterService,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private messagesDelegate: MessagesDelegate) {
    this.editing$ = this.eventsEmitterService.listen('editing')
    this.routingSub = this.route.params.subscribe(this.onRouting.bind(this))
  }

  ngOnDestroy () {
    this.routingSub.unsubscribe()
  }

  async onRouting (params) {
    const currentUser = this.usersService.currentUser

    try {
      this.user = params.id === currentUser.id ? currentUser : await this.usersService.getById(params.id)
    } catch (err) {
      this.messagesDelegate.add(err.status === 404 ? 'APP.USER.NOT_FOUND' : err.message, true)
      return
    }

    if (currentUser.isAdmin() || currentUser.id === params.id) {
      this.eventsEmitterService.emit('showAdminMenu', true)
    }

    this.eventsEmitterService.emit('editing', false)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/user/user.component.ts